<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <settingsMenu></settingsMenu>
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Rodzaje etatów</h4>
              <button @click="addTyp" class="btn btn-primary btn-sm">
                <i class="bi bi-plus-circle me-2"></i>Dodaj nowy rodzaj etatu
              </button>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="custom-table">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Nazwa rodzaju etatu</th>
                  <th>Opis</th>
                  <th>Etat od</th>
                  <th>Etat do</th>
                  <th>Jaki etat</th>
                  <th>Akcje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(typ, index) in etaty_typy" :key="index">
                  <td style="width:50px;">{{ index + 1 }}</td>
                  <td>
                    <input v-if="editingId === typ.id" v-model="typ.nazwa" class="form-control"/>
                    <span v-else>{{ typ.nazwa }}</span>
                  </td>
                  <td>
                    <textarea v-if="editingId === typ.id" v-model="typ.opis" class="form-control" rows="3"></textarea>
                    <span v-else>{{ typ.opis }}</span>
                  </td>
                  <td style="width:110px;">
                    <input v-if="editingId === typ.id" v-model="typ.etat_od" class="form-control"/>
                    <span v-else>{{ typ.etat_od }}</span>
                  </td>
                  <td style="width:110px;">
                    <input v-if="editingId === typ.id" v-model="typ.etat_do" class="form-control"/>
                    <span v-else>{{ typ.etat_do }}</span>
                  </td>
                  <td style="width:110px;">
                    {{ typ.etat_od / typ.etat_do }}
                  </td>
                  <td>
                    <button v-if="editingId === typ.id" @click="updateTyp(typ)"
                            class="btn btn-sm btn-success me-2 mb-1">Zapisz
                    </button>
                    <button v-else @click="editTyp(typ.id)" class="btn btn-sm btn-outline-info me-2 mb-1"><i
                        class="bi bi-pencil me-2"></i>Edytuj
                    </button>
                    <button @click="deleteTyp(typ.id)" class="btn btn-sm btn-danger mb-1"><i
                        class="bi bi-trash me-2"></i>Usuń
                    </button>
                  </td>
                </tr>
                <tr v-if="addingNew">
                  <td style="width:50px;">Nowy</td>
                  <td><input v-model="newTyp.nazwa" class="form-control"/></td>
                  <td><textarea v-model="newTyp.opis" class="form-control" rows="3"></textarea></td>
                  <td style="width:110px;"><input v-model="newTyp.etat_od" class="form-control"/></td>
                  <td style="width:110px;"><input v-model="newTyp.etat_do" class="form-control"/></td>
                  <td style="width:110px;">
                    <span v-if="newTyp.etat_od> 0 && newTyp.etat_do > 0">{{ newTyp.etat_od / newTyp.etat_do }}</span>

                  </td>
                  <td>
                    <button @click="saveNewTyp" class="btn btn-sm btn-success me-1 mb-1"><i class="bi bi-save me-2"></i>Zapisz
                    </button>
                    <button @click="cancelNewTyp" class="btn btn-sm btn-danger mb-1"><i class="bi bi-x-circle me-2"></i>Anuluj
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import settingsMenu from "@/Pages/Kadry/parts/settingsMenu.vue";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, settingsMenu},
  props: {
    etaty_typy: Array
  },
  data() {
    return {
      hasPermission,
      editingId: null,
      addingNew: false,
      newTyp: this.getEmptyForm()
    };
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return date.toISOString().split('T')[0];
    },
    getEmptyForm() {
      return {
        id: null,
        name: '',
        opis: '',
        etat_od: '',
        etat_do: ''
      };
    },
    addTyp() {
      this.addingNew = true;
      this.newTyp = this.getEmptyForm();
    },
    cancelNewTyp() {
      this.addingNew = false;
      this.newTyp = this.getEmptyForm();
    },
    editTyp(id) {
      this.editingId = id;
    },

    updateTyp(typ) {
      this.$inertia.put(route('kadry.etaty_typy.update', typ.id), typ, {
        onSuccess: () => {
          this.editingId = null;
        }
      });
    },
    saveNewTyp() {
      this.$inertia.post(route('kadry.etaty_typy.dodaj'), this.newTyp, {
        onSuccess: () => {
          this.addingNew = false;
          this.newTyp = this.getEmptyForm();
        }
      });
    },
    deleteTyp(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie rodzaju etatu',
        html: 'Czy na pewno chcesz usunąć wybrany rodzaj rodzaj etatu?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('kadry.etaty_typy.usun', id));
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
